import { render, staticRenderFns } from "./SlotPrice.vue?vue&type=template&id=049ea606&"
import script from "./SlotPrice.vue?vue&type=script&lang=js&"
export * from "./SlotPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports